/**
 * Formata um valor numérico para o padrão de moeda brasileiro (R$ 1.234,56).
 * @param {number|string} value - O valor a ser formatado.
 * @returns {string} - O valor formatado como moeda.
 */
export const formatCurrency = (value) => {
    const number = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(number)) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(number);
};

/**
 * Formata um valor numérico para o padrão decimal brasileiro (1.234,56).
 * @param {number|string} value - O valor a ser formatado.
 * @param {number} decimals - Número de casas decimais (padrão 2).
 * @returns {string} - O valor formatado.
 */
export const formatNumber = (value, decimals = 2) => {
    const number = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(number)) return '0,00';
    return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    }).format(number);
};

/**
 * Converte uma string no formato brasileiro (1.234,56) para um número flutuante (1234.56).
 * @param {string} value - A string a ser convertida.
 * @returns {number} - O número convertido.
 */
export const parseBrazilianNumber = (value) => {
    if (!value) return 0;
    if (typeof value === 'number') return value;
    // Remove pontos de milhar e substitui vírgula por ponto
    const normalized = value.replace(/\./g, '').replace(',', '.');
    return parseFloat(normalized) || 0;
};
